import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "message"]
  
  connect() {
    // Reserved usernames list kept for future use but not actively checked yet
  }
  
  suggestUsername(event) {
    const businessName = event.target.value
    const brandUsernameInput = document.querySelector('[data-brand-username-target="input"]')
    
    if (businessName && brandUsernameInput && !brandUsernameInput.value) {
      // Suggest a username based on business name
      const suggested = businessName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '')
        .substring(0, 20)
      
      brandUsernameInput.placeholder = suggested || 'acmemotorcoach'
    }
  }
  
  checkReservation(event) {
    const username = event.target.value.toLowerCase().trim()
    
    if (!username) {
      this.hideMessage()
      return
    }
    
    // Treat all usernames the same - no special handling for reserved ones yet
    this.showAvailableMessage(username)
  }
  
  showAvailableMessage(username) {
    if (username.length < 3) {
      this.messageTarget.classList.remove('hidden')
      this.messageTarget.innerHTML = `
        <div class="flex items-start space-x-2 p-3 bg-gray-50 border border-gray-200 rounded-lg">
          <i class="fas fa-info-circle text-gray-500 mt-0.5"></i>
          <div>
            <p class="text-sm text-gray-600">Username must be at least 3 characters</p>
          </div>
        </div>
      `
    } else {
      this.messageTarget.classList.remove('hidden')
      this.messageTarget.innerHTML = `
        <div class="flex items-start space-x-2 p-3 bg-green-50 border border-green-200 rounded-lg">
          <i class="fas fa-check-circle text-green-600 mt-0.5"></i>
          <div>
            <p class="text-sm text-green-700">@${username} looks good!</p>
          </div>
        </div>
      `
    }
  }
  
  hideMessage() {
    this.messageTarget.classList.add('hidden')
  }
}